(function () {
  'use strict';

  const STORAGE_KEY = 'rasasi_delivery_location';
  const SKIP_KEY = 'rasasi_delivery_skipped';

  let areasData = null;
  let festivalDates = null; // Set of "YYYY-MM-DD" strings to skip like Sundays
  let modalEl = null;
  let listenersBound = false;

  function readJSON(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function getLocation() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) { return null; }
  }

  function setLocation(emirate, area) {
    const value = { emirate, area, setAt: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    localStorage.removeItem(SKIP_KEY);
    renderAll();
    document.dispatchEvent(new CustomEvent('rasasi:delivery-location-change', { detail: value }));
    closeModal();
  }

  function clearLocation() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(SKIP_KEY);
    renderAll();
    document.dispatchEvent(new CustomEvent('rasasi:delivery-location-change', { detail: null }));
  }

  function markSkipped() {
    localStorage.setItem(SKIP_KEY, '1');
  }

  function shouldAutoOpen() {
    return !getLocation() && !localStorage.getItem(SKIP_KEY);
  }

  // Drive the modal through the shared RasasiOverlay controller (overlays.js).
  // Both the data-overlay-open triggers and these programmatic calls act on the
  // same [data-open] state + shared backdrop, so there is never an orphaned
  // backdrop after selecting an area.
  function openModal() {
    if (window.RasasiOverlay) window.RasasiOverlay.open('delivery-location-modal');
  }

  function closeModal() {
    if (window.RasasiOverlay) window.RasasiOverlay.close('delivery-location-modal');
  }

  function buildAreaList(filter) {
    const groups = modalEl.querySelectorAll('[data-delivery-emirate]');
    let total = 0;
    const q = (filter || '').trim().toLowerCase();

    groups.forEach((groupEl) => {
      const emirate = groupEl.getAttribute('data-delivery-emirate');
      const ul = groupEl.querySelector('[data-delivery-emirate-list]');
      const items = Object.keys(areasData[emirate] || {}).filter((a) => {
        if (!q) return true;
        return a.toLowerCase().includes(q) || emirate.toLowerCase().includes(q);
      });

      const nextChildren = items.map((area) => {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'w-full text-left py-2 px-2 text-sm hover:bg-gray-50';
        btn.textContent = area;
        btn.setAttribute('data-delivery-pick-emirate', emirate);
        btn.setAttribute('data-delivery-pick-area', area);
        li.appendChild(btn);
        return li;
      });

      ul.replaceChildren(...nextChildren);

      if (items.length === 0) {
        groupEl.classList.add('hidden');
      } else {
        groupEl.classList.remove('hidden');
        total += items.length;
      }
    });

    const noResults = modalEl.querySelector('[data-delivery-no-results]');
    if (noResults) noResults.classList.toggle('hidden', total > 0);
  }

  function bindModalListeners() {
    if (listenersBound) return;
    listenersBound = true;

    const search = modalEl.querySelector('[data-delivery-search]');
    if (search) search.addEventListener('input', (e) => buildAreaList(e.target.value));

    modalEl.addEventListener('click', (e) => {
      const pickBtn = e.target.closest('[data-delivery-pick-emirate]');
      if (pickBtn) {
        setLocation(
          pickBtn.getAttribute('data-delivery-pick-emirate'),
          pickBtn.getAttribute('data-delivery-pick-area')
        );
        return;
      }
      const geoBtn = e.target.closest('[data-delivery-geolocate]');
      if (geoBtn) { handleGeolocate(); return; }
      const skipBtn = e.target.closest('[data-delivery-skip]');
      if (skipBtn) markSkipped();
    });
  }

  function renderAll() {
    const loc = getLocation();
    document.querySelectorAll('[data-delivery-location-target]').forEach((el) => {
      if (!loc) {
        el.setAttribute('data-state', 'empty');
        return;
      }

      el.querySelectorAll('[data-delivery-area]').forEach((areaEl) => {
        areaEl.textContent = `${loc.emirate} – ${loc.area}`;
      });

      const days = durationFor(loc.emirate, loc.area);
      if (days === 0) {
        // Area is in our list but Aramex doesn't deliver there — show the
        // polite "we don't deliver here" message (driven by data-state in CSS).
        el.setAttribute('data-state', 'unserviceable');
        return;
      }
      if (days == null) {
        // Stored area is no longer in the data set (list changed) — re-prompt.
        el.setAttribute('data-state', 'empty');
        return;
      }

      el.setAttribute('data-state', 'selected');
      const getItByEl = el.querySelector('[data-delivery-get-it-by]');
      if (getItByEl) getItByEl.textContent = formatGetItBy(loc.emirate, loc.area);
      const countdownEl = el.querySelector('[data-delivery-countdown]');
      if (countdownEl) {
        const cutoffHour = parseInt(el.getAttribute('data-delivery-cutoff-hour') || '12', 10);
        countdownEl.textContent = formatCountdown(cutoffHour);
      }
    });
  }

  function getLocaleTag() {
    const lang = (modalEl && modalEl.getAttribute('data-locale')) || document.documentElement.lang || 'en';
    return lang.startsWith('ar') ? 'ar-AE' : 'en-GB';
  }

  const UAE_TZ = 'Asia/Dubai';
  const DATE_FORMAT = 'YYYY-MM-DD';

  // Idempotently register Day.js plugins. Called lazily so we don't crash
  // if delivery-location.js is loaded ahead of the dayjs CDN bundle (defer
  // order normally prevents this, but the guard is cheap).
  function dayjsReady() {
    if (typeof window.dayjs !== 'function') return null;
    const d = window.dayjs;
    if (window.dayjs_plugin_utc && !d.__rasasiUtc) { d.extend(window.dayjs_plugin_utc); d.__rasasiUtc = true; }
    if (window.dayjs_plugin_timezone && !d.__rasasiTz) { d.extend(window.dayjs_plugin_timezone); d.__rasasiTz = true; }
    if (window.dayjs_plugin_customParseFormat && !d.__rasasiCpf) { d.extend(window.dayjs_plugin_customParseFormat); d.__rasasiCpf = true; }
    return d;
  }

  function nowInUAE() {
    const dj = dayjsReady();
    return dj ? dj().tz(UAE_TZ) : null;
  }

  function durationFor(emirate, area) {
    const group = areasData && areasData[emirate];
    if (!group) return null;
    const d = group[area];
    return Number.isFinite(d) ? d : null;
  }

  function ymd(djInstance) {
    return djInstance.format(DATE_FORMAT);
  }

  function isSkipDate(djInstance) {
    if (djInstance.day() === 0) return true;                                    // Sunday
    if (festivalDates && festivalDates.has(ymd(djInstance))) return true;       // Closed days
    return false;
  }

  // Compute the expected arrival date for the given duration in business days.
  // Rules:
  //   - Cutoff is the cutoffHour (default 12 PM UAE). If "now" is past the
  //     cutoff the order is processed the next day, so add 1 day to duration.
  //   - Sunday and any merchant-configured festival/holiday closed dates do
  //     not count as a delivery day.
  function computeArrivalDate(durationDays, cutoffHour) {
    const now = nowInUAE();
    if (!now) return null;
    let remaining = durationDays;
    if (now.hour() >= cutoffHour) remaining += 1;
    let cursor = now;
    while (remaining > 0) {
      cursor = cursor.add(1, 'day');
      if (!isSkipDate(cursor)) remaining -= 1;
    }
    return cursor;
  }

  // Returns "Saturday, 23 May" for the customer's area, computed in UAE time.
  function formatGetItBy(emirate, area, cutoffHour) {
    const days = durationFor(emirate, area);
    if (days == null || days <= 0) return ''; // unknown or non-serviceable area
    const cutoff = Number.isFinite(cutoffHour) ? cutoffHour : 12;
    const arrival = computeArrivalDate(days, cutoff);
    if (!arrival) return '';
    // Use Intl for the localized weekday/month name (Day.js's built-in formatter
    // doesn't localize without an extra locale file). Build a Date in UTC at
    // midnight UAE so Intl renders the same calendar day Day.js gave us.
    const fmt = new Intl.DateTimeFormat(getLocaleTag(), {
      weekday: 'long', day: 'numeric', month: 'short', timeZone: UAE_TZ,
    });
    return fmt.format(arrival.toDate());
  }

  // "Order within Xh Ym" — time left until today's cutoff (UAE time).
  // After the cutoff, counts down to tomorrow's cutoff.
  function formatCountdown(cutoffHour) {
    const now = nowInUAE();
    if (!now) return '';
    let cutoff = now.hour(cutoffHour).minute(0).second(0).millisecond(0);
    if (cutoff.isBefore(now) || cutoff.isSame(now)) cutoff = cutoff.add(1, 'day');
    const totalMinutes = Math.max(0, cutoff.diff(now, 'minute'));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }

  function showGeoError(messageKey, vars) {
    const el = modalEl.querySelector('[data-delivery-geo-error]');
    if (!el) return;
    const t = document.getElementById('theme-translations');
    const map = {
      'delivery.geolocation_error': (t && t.dataset.deliveryGeoError) || "Couldn't get your location. Please pick from the list.",
      'delivery.geolocation_no_match': (t && t.dataset.deliveryGeoNoMatch) || "Couldn't auto-detect — please pick manually.",
      'delivery.geolocation_outside_uae': (t && t.dataset.deliveryGeoOutsideUae) || "We detected you in {location}. We deliver only within the UAE — please pick your area from the list.",
      'delivery.geolocation_inside_no_match': (t && t.dataset.deliveryGeoInsideNoMatch) || "We detected you near {location}. Please pick your area from the list.",
    };
    let text = map[messageKey] || '';
    if (vars) {
      Object.keys(vars).forEach((k) => {
        text = text.replace(new RegExp('\\{' + k + '\\}', 'g'), vars[k]);
      });
    }
    el.textContent = text;
    el.classList.remove('hidden');
  }

  function clearGeoError() {
    const el = modalEl.querySelector('[data-delivery-geo-error]');
    if (el) el.classList.add('hidden');
  }

  function setGeolocateLabel(text) {
    const el = modalEl.querySelector('[data-delivery-geolocate-label]');
    if (el) el.textContent = text;
  }

  function matchAreaFromMapbox(features) {
    const candidates = [];
    features.forEach((f) => {
      if (f.place_name) candidates.push(f.place_name.toLowerCase());
      if (f.text) candidates.push(f.text.toLowerCase());
    });
    const emirates = Object.keys(areasData);
    for (const emirate of emirates) {
      const emirateLower = emirate.toLowerCase();
      for (const area of Object.keys(areasData[emirate] || {})) {
        const areaLower = area.toLowerCase();
        if (candidates.some((c) => c.includes(areaLower))) {
          return { emirate, area };
        }
      }
      if (candidates.some((c) => c.includes(emirateLower))) {
        return { emirate, area: null };
      }
    }
    return null;
  }

  function getDetectedLocation(features) {
    if (!features || !features.length) return null;
    for (const f of features) {
      const ctx = f.context || [];
      const country = ctx.find((c) => c.id && c.id.startsWith('country'));
      const place = ctx.find((c) => c.id && (c.id.startsWith('place') || c.id.startsWith('region')));
      if (country) {
        return {
          country: country.text,
          countryCode: (country.short_code || '').toUpperCase(),
          place: place ? place.text : f.text,
        };
      }
    }
    const first = features[0];
    return { country: null, countryCode: null, place: first.text || first.place_name || '' };
  }

  function handleGeolocate() {
    const token = modalEl.getAttribute('data-mapbox-token');
    if (!token) { showGeoError('delivery.geolocation_error'); return; }
    if (!navigator.geolocation) { showGeoError('delivery.geolocation_error'); return; }

    clearGeoError();
    const labelEl = modalEl.querySelector('[data-delivery-geolocate-label]');
    const originalLabel = labelEl ? labelEl.textContent : '';
    const t = document.getElementById('theme-translations');
    const detectingLabel = (t && t.dataset.deliveryDetecting) || 'Detecting…';
    setGeolocateLabel(detectingLabel);

    const onPositionFix = (pos) => {
      const { latitude, longitude } = pos.coords;
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${encodeURIComponent(token)}&types=neighborhood,locality,district,place,address,region,country`;
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error('mapbox http ' + res.status);
          return res.json();
        })
        .then((json) => {
          setGeolocateLabel(originalLabel);
          const features = json.features || [];
          const detected = getDetectedLocation(features);

          if (detected && detected.countryCode && detected.countryCode !== 'AE') {
            const where = detected.place ? `${detected.place}, ${detected.country}` : detected.country;
            showGeoError('delivery.geolocation_outside_uae', { location: where });
            return;
          }

          const match = matchAreaFromMapbox(features);
          if (match) {
            const area = match.area || (areasData[match.emirate] && Object.keys(areasData[match.emirate])[0]);
            if (area) { setLocation(match.emirate, area); return; }
          }

          if (detected && (detected.place || detected.country)) {
            const where = detected.place || detected.country;
            showGeoError('delivery.geolocation_inside_no_match', { location: where });
          } else {
            showGeoError('delivery.geolocation_no_match');
          }
        })
        .catch(() => {
          setGeolocateLabel(originalLabel);
          showGeoError('delivery.geolocation_error');
        });
    };

    // When the browser Geolocation API can't get coordinates from the OS
    // (Wi-Fi off, location services off, no GPS), fall back to server-side
    // IP geolocation so we can at least tell the customer which country
    // we detected them in.
    const ipFallback = () => {
      fetch('https://ipapi.co/json/')
        .then((r) => {
          if (!r.ok) throw new Error('ipapi http ' + r.status);
          return r.json();
        })
        .then((ip) => {
          setGeolocateLabel(originalLabel);
          const countryCode = (ip.country_code || '').toUpperCase();
          const country = ip.country_name || '';
          const place = ip.city || ip.region || country;

          if (countryCode && countryCode !== 'AE') {
            const where = place ? `${place}, ${country}` : country;
            showGeoError('delivery.geolocation_outside_uae', { location: where });
            return;
          }
          if (countryCode === 'AE') {
            showGeoError('delivery.geolocation_inside_no_match', { location: place || 'UAE' });
            return;
          }
          showGeoError('delivery.geolocation_error');
        })
        .catch(() => {
          setGeolocateLabel(originalLabel);
          showGeoError('delivery.geolocation_error');
        });
    };

    const onPositionError = (err) => {
      // POSITION_UNAVAILABLE often means the OS couldn't fix a position with the
      // low-accuracy (Wi-Fi/IP) provider — retry once with GPS hardware if available.
      if (err && err.code === 2) {
        navigator.geolocation.getCurrentPosition(
          onPositionFix,
          () => ipFallback(),
          { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
        return;
      }
      // PERMISSION_DENIED: skip IP lookup — would feel like a privacy workaround.
      if (err && err.code === 1) {
        setGeolocateLabel(originalLabel);
        showGeoError('delivery.geolocation_error');
        return;
      }
      // TIMEOUT and anything else: try IP fallback.
      ipFallback();
    };

    navigator.geolocation.getCurrentPosition(
      onPositionFix,
      onPositionError,
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
    );
  }

  function tickCountdowns() {
    // Live-update only the countdown text — cheap and avoids touching the rest.
    const loc = getLocation();
    if (!loc) return;
    document.querySelectorAll('[data-delivery-location-target][data-state="selected"] [data-delivery-countdown]').forEach((el) => {
      const wrap = el.closest('[data-delivery-location-target]');
      const cutoffHour = parseInt((wrap && wrap.getAttribute('data-delivery-cutoff-hour')) || '12', 10);
      el.textContent = formatCountdown(cutoffHour);
    });
  }

  // Re-hydrate any delivery-estimate markup that gets injected later by
  // section-render refreshes (e.g. quick-cart drawer after add/update).
  function observeDom() {
    if (!('MutationObserver' in window)) return;
    let scheduled = false;
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          const isTarget = node.matches && node.matches('[data-delivery-location-target]');
          const hasTarget = node.querySelector && node.querySelector('[data-delivery-location-target]');
          if (isTarget || hasTarget) {
            if (!scheduled) {
              scheduled = true;
              (window.queueMicrotask || ((fn) => setTimeout(fn, 0)))(() => {
                scheduled = false;
                renderAll();
              });
            }
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // Listen for the universal cart:changed event from assets/cart-observer.js
  // and re-hydrate over the window the cart refresh typically completes in.
  // The MutationObserver catches most cases, but innerHTML swaps inside a
  // deeply-nested container occasionally race with our microtask schedule.
  function listenForCartChanges() {
    document.addEventListener('cart:changed', () => {
      [0, 150, 400, 800].forEach((delay) => setTimeout(renderAll, delay));
    });
  }

  // Returns a Day.js instance (UAE TZ, midnight) for a valid YYYY-MM-DD string,
  // or null. Day.js with customParseFormat in strict mode rejects rollover
  // dates (e.g. 2026-02-30, 2026-99-99).
  function parseYMD(s) {
    const dj = dayjsReady();
    if (!dj) return null;
    const parsed = dj(s, DATE_FORMAT, true);
    return parsed.isValid() ? parsed.tz(UAE_TZ, true) : null;
  }

  // Single festival window {start, end}. Both must be valid YYYY-MM-DD;
  // start must not be after end; range expansion is capped at 366 days
  // to guard against typos like 1900 - 2099.
  function loadFestivalDates() {
    festivalDates = new Set();
    const range = readJSON('delivery-festival-range') || {};
    const startStr = (range.start || '').trim();
    const endStr = (range.end || '').trim();
    if (!startStr || !endStr) return;
    const start = parseYMD(startStr);
    const end = parseYMD(endStr);
    if (!start || !end || end.isBefore(start)) return;
    let cursor = start;
    let safety = 0;
    while (!cursor.isAfter(end) && safety < 366) {
      festivalDates.add(ymd(cursor));
      cursor = cursor.add(1, 'day');
      safety += 1;
    }
  }

  function init() {
    modalEl = document.getElementById('delivery-location-modal');
    if (!modalEl) return;
    // Single source of truth: { emirate: { area: durationDays } }.
    areasData = readJSON('delivery-area-durations') || {};
    loadFestivalDates();
    bindModalListeners();
    buildAreaList('');
    renderAll();
    observeDom();
    listenForCartChanges();
    if (shouldAutoOpen()) openModal();
    setInterval(tickCountdowns, 60000);
  }

  window.RasasiDeliveryLocation = {
    get: getLocation,
    set: setLocation,
    clear: clearLocation,
    open: openModal,
    close: closeModal,
    render: renderAll,
    formatGetItBy,
    formatCountdown,
    durationFor,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
